import { render, staticRenderFns } from "./PrintDocument.vue?vue&type=template&id=672d3576"
import script from "./PrintDocument.vue?vue&type=script&lang=js"
export * from "./PrintDocument.vue?vue&type=script&lang=js"
import style0 from "./PrintDocument.vue?vue&type=style&index=0&id=672d3576&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports